module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-ace.4af91153.svg";